import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { OrdersService } from '../../../core/services/orders/orders.service';
import { AlertService } from '../../../core/services/alert/alert.service';
import { AuthStateService } from '../../../core/services/auth-state/auth-state-service.service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { BadgeColorPipe } from '../../../core/pipe/badge-color.pipe';
import { BadgeVehiclePipe } from '../../../core/pipe/badge-vehicle.pipe';
import { BadgeClientPipe } from '../../../core/pipe/badge-client.pipe';
import { resolveNotesRule } from '../../../core/utils/form.utils';

@Component({
  selector: 'app-update-order-stage',
  standalone: true,
  imports: [ReactiveFormsModule,CommonModule, TranslateModule, MatDatepickerModule, MatFormFieldModule,
      MatInputModule,
      MatDatepickerModule,
      BadgeColorPipe,
      BadgeVehiclePipe,
      BadgeClientPipe],
  templateUrl: './update-order-stage.component.html',
  styleUrl: './update-order-stage.component.css'
})
export class UpdateOrderStageComponent {

  orderData: any;
  isLoading: boolean = true;
  errorMessage: string = '';
  stage?: any;
  showImportantDates = false;
  updateStageForm: FormGroup;
  clocks: any[] = [];
  isUpdating: boolean = false;
  btn_fast_actions = false;
  newStage: string = '';

  hasFormChanges: boolean = false;

  next_ok = "";
  next_ko = "";

   constructor(
      private route: ActivatedRoute,
      private orderService: OrdersService,
      private alertService: AlertService,
      private translateService: TranslateService,
      private authStateService: AuthStateService,
      private fb: FormBuilder,
    ) {
      this.updateStageForm = this.fb.group({
          notes_visibility: ["public", Validators.required],
          stage: ['draft', Validators.required],
          notes:[""]
       });
    }

  ngOnInit() {
    this.loadPublicOrder();
    this.setupFormChangeTracking();
  }

  private setupFormChangeTracking() {
    this.updateStageForm.valueChanges.subscribe(() => {
      this.checkFormChanges();
    });

    this.updateStageForm.get('stage')?.valueChanges.subscribe(() => {
      this.checkFormChanges();
    });

    this.updateStageForm.get('notes')?.valueChanges.subscribe(() => {
      this.checkFormChanges();
    });
  }

  private checkFormChanges() {
    if (!this.orderData) {
      this.hasFormChanges = false;
      return;
    }

    const currentFormValues = this.updateStageForm.value;
    this.hasFormChanges =
      currentFormValues.stage !== this.orderData.stage ||
      currentFormValues.notes !== (this.orderData.notes || '') ||
      currentFormValues.notes_visibility !== (this.orderData.notes_visibility || 'public');
  }

   loadPublicOrder() {
    this.route.params.subscribe(params => {
      const reference = params['reference'];
      this.route.queryParams.subscribe(queryParams => {
        const token = queryParams['token'];

        this.orderService.getPublicOrder(reference, token).subscribe({
          next: (response: any) => {
            this.orderData = response.data;
            this.setVariables();
            this.isLoading = false;
            this.checkFormChanges();
          },
          error: (error: any) => {
            console.error('Error:', error);
            this.isLoading = false;
            this.errorMessage = this.getErrorMessage(error);
          }
        });
      });
    });
  }
  setVariables() {
    this.stage = this.orderData?.stage;
    this.setFormData();
  }

   getErrorMessage(error: any): string {
    if (error.status === 410) {
      return 'Este enlace ya ha sido utilizado';
    } else if (error.status === 404) {
      return 'El enlace ha expirado o es inválido';
    } else {
      return this.translateService.instant('swal_messages.error_order');
    }
  }

   private setFormData() {
    if (this.orderData) {
      this.updateStageForm.patchValue({
        notes_visibility: this.orderData.notes_visibility || '',
        stage: this.orderData.stage || 'draft',
        notes: this.orderData.notes || ''
      });
      this.hasFormChanges = false;
    }
  }

 updateOrder() {
  if (!this.updateStageForm.get('stage')?.value) {
    this.alertService.error('Por favor, complete la fecha de entrega esperada');
    return;
  }

  this.isUpdating = true;
  const reference = this.route.snapshot.params['reference'];
  const token = this.route.snapshot.queryParams['token'];

  const updateData: any = {
    notes_visibility: 'public',
    stage: this.updateStageForm.get('stage')?.value
  };

  // Campos opcionales
  const notes = this.updateStageForm.get('notes')?.value?.trim();
  if (notes) {
    updateData.notes = notes;
  }

  const licensePlate = this.updateStageForm.get('license_plate')?.value?.trim();
  if (licensePlate) {
    updateData.license_plate = licensePlate;
  }

  console.log('Payload a enviar:', updateData);
  this.alertService.loading('swal_messages.please_wait');
  this.orderService.updatePublicOrder(reference, token, updateData).subscribe({
    next: (response: any) => {
      this.isUpdating = false;
      this.alertService.success('swal_messages.order_updated');
      this.loadPublicOrder();
    },
    error: (error: any) => {
      this.isUpdating = false;
      console.error('Error al actualizar:', error);

      if (error.status === 410) {
        this.alertService.error('Este enlace ya ha sido utilizado para actualizar');
      } else {
        this.alertService.error('swal_messages.order_status_error');
      }
    }
  });
}

changeStage(event: any) {
    this.newStage = event;
    this.btn_fast_actions = false;
  }

  updateFieldAccessibility() {
    var rules: Record<string, any> = { ...resolveNotesRule(this.orderData?.rules, 'public'), notes_visibility: 'w' };
    for (const field in this.updateStageForm.controls) {
      if (this.updateStageForm.controls.hasOwnProperty(field)) {
        this.updateStageForm.get(field)?.disable();
      }
    }

    for (const field in rules) {
      if (rules.hasOwnProperty(field) && rules[field] === 'w') {
        this.updateStageForm.get(field)?.enable();
      }
    }

  }
}
